module.exports = __webpack_public_path__ + "static/img/three.a61b89a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wardrobeImg/three.png
// module id = iNXA
// module chunks = 1